import axios from 'axios';
import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';
import { OrderLineItemDTO } from '../interfaces/orderLineItem.interfaces';

interface OrderLineItemsRequest {
  orderId: string;
  organizationId: number;
}

export const fetchOrderLineItems = async (
  reqParams: OrderLineItemsRequest,
): Promise<{ data: OrderLineItemDTO[] }> => {
  try {
    const { orderId, organizationId } = reqParams;

    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/order-line-items/${organizationId}/`;

    const { data } = await axios.get(url, {
      params: {
        order_id: orderId,
      },
    });

    return data;
  } catch (error) {
    throw new APIError(error.message);
  }
};
